export default __webpack_public_path__ + "pgnv-assets/ebf4e3861c0d3f71cb8f4ae21e3cb3a2.png";